import { createWorker, PSM, type Worker } from 'tesseract.js'

export type OcrProgress = {
  status: string
  progress: number
}

export type OcrResult = {
  text: string
  confidence: number
}

let listener: ((progress: OcrProgress) => void) | undefined
let workerPromise: Promise<Worker> | undefined

function getWorker() {
  if (!workerPromise) {
    workerPromise = createWorker('spa', 1, {
      logger(message) {
        listener?.({
          status: typeof message.status === 'string' ? message.status : 'Procesando',
          progress: typeof message.progress === 'number' ? message.progress : 0
        })
      }
    }).then(async worker => {
      await worker.setParameters({
        tessedit_pageseg_mode: PSM.AUTO,
        preserve_interword_spaces: '1',
        user_defined_dpi: '300'
      })
      return worker
    }).catch(error => {
      workerPromise = undefined
      throw error
    })
  }
  return workerPromise
}

export function cleanOcrText(value: string) {
  return value
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

export async function recognizeSheetText(photo: File, onProgress: (progress: OcrProgress) => void): Promise<OcrResult> {
  listener = onProgress
  try {
    const worker = await getWorker()
    const result = await worker.recognize(photo, { rotateAuto: true })
    return {
      text: cleanOcrText(result.data.text || ''),
      confidence: Number.isFinite(result.data.confidence) ? Math.round(result.data.confidence) : 0
    }
  } finally {
    listener = undefined
  }
}

export async function recognizeFieldText(image: Blob, mode: 'word' | 'line' | 'block' = 'line'): Promise<OcrResult> {
  const worker = await getWorker()
  await worker.setParameters({
    tessedit_pageseg_mode: mode === 'word' ? PSM.SINGLE_WORD : mode === 'block' ? PSM.SINGLE_BLOCK : PSM.SINGLE_LINE,
    preserve_interword_spaces: '1',
    user_defined_dpi: '300'
  })
  const result = await worker.recognize(image)
  return {
    text: cleanOcrText(result.data.text || ''),
    confidence: Number.isFinite(result.data.confidence) ? Math.round(result.data.confidence) : 0
  }
}
